import { useEffect, useState } from 'react';
import { useSession } from '../../context/SessionContext';
import { ApiError } from '../../lib/api';
import { PinBoxInput } from '../../components/PinBoxInput';
import { ThemeToggle } from '../../components/ThemeToggle';

const EMPLOYEE_TEL_KEY = 'coala.employeeTelefone';

export function LoginScreen() {
  const [mode, setMode] = useState<'employee' | 'manager' | 'forgot'>('employee');
  const [loginTelefone, setLoginTelefone] = useState(() => localStorage.getItem(EMPLOYEE_TEL_KEY) || '');
  const [pin, setPin] = useState('');
  const [pwd, setPwd] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const { loginEmployee, loginManager, resetPin } = useSession();

  const [cpf, setCpf] = useState('');
  const [telefone, setTelefone] = useState('');
  const [novoPin, setNovoPin] = useState('');
  const [novoPin2, setNovoPin2] = useState('');

  useEffect(() => { localStorage.setItem(EMPLOYEE_TEL_KEY, loginTelefone); }, [loginTelefone]);

  function limparTelefone() {
    setLoginTelefone('');
    localStorage.removeItem(EMPLOYEE_TEL_KEY);
  }

  async function doLoginEmployee() {
    setError(''); setBusy(true);
    try {
      await loginEmployee(loginTelefone.trim(), pin.trim());
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Telefone ou PIN incorretos. Confira com o gestor.');
    } finally {
      setBusy(false);
    }
  }
  async function doLoginManager() {
    setError(''); setBusy(true);
    try {
      await loginManager(pwd);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Senha incorreta.');
    } finally {
      setBusy(false);
    }
  }
  async function doResetPin() {
    setError('');
    if (!/^\d{4}$/.test(novoPin)) { setError('O novo PIN precisa ter exatamente 4 dígitos.'); return; }
    if (novoPin !== novoPin2) { setError('Os dois PINs digitados são diferentes.'); return; }
    setBusy(true);
    try {
      await resetPin(cpf.trim(), telefone.trim(), novoPin.trim());
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Não foi possível trocar o PIN.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap" style={{ position: 'relative', width: '100%' }}>
      <div style={{ position: 'absolute', top: 0, right: 16 }}><ThemeToggle /></div>
      <div className="brand" style={{ justifyContent: 'center' }}>
        <div className="stamp-mark"><span>C</span></div>
        <div style={{ textAlign: 'left' }}>
          <div className="brand-name">Coala Registra</div>
          <div className="brand-sub">Ponto · Vales · Documentos</div>
        </div>
      </div>
      <div className="card login-card">
        {mode === 'employee' && (
          <>
            <h2>Bater o ponto</h2>
            <p className="hint">Entre com seu telefone e o PIN de 4 dígitos recebido do gestor.</p>
            <label>Telefone</label>
            <div className="row" style={{ gap: 8 }}>
              <input
                type="tel"
                placeholder="(71) 90000-0000"
                style={{ flex: 1 }}
                value={loginTelefone}
                onChange={(e) => setLoginTelefone(e.target.value)}
                autoFocus={!loginTelefone}
              />
              {loginTelefone && <button type="button" className="btn btn-ghost btn-sm" onClick={limparTelefone}>Limpar</button>}
            </div>
            <label style={{ marginTop: 10 }}>PIN (senha)</label>
            <PinBoxInput value={pin} onChange={setPin} onEnter={doLoginEmployee} autoFocus={!!loginTelefone} />
            {error && <div className="err">{error}</div>}
            <button className="btn btn-primary btn-block" style={{ marginTop: 14 }} disabled={busy} onClick={doLoginEmployee}>Entrar</button>
            <div className="switch-role">
              <a onClick={() => { setMode('forgot'); setError(''); }}>Esqueceu seu PIN?</a>
            </div>
            <div className="switch-role">Você é o gestor? <a onClick={() => { setMode('manager'); setError(''); }}>Entrar como gestor</a></div>
          </>
        )}

        {mode === 'manager' && (
          <>
            <h2>Acesso do gestor</h2>
            <p className="hint">Senha mestre do painel administrativo.</p>
            <input
              type="password"
              className="pin-input"
              placeholder="••••"
              maxLength={40}
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') doLoginManager(); }}
            />
            {error && <div className="err">{error}</div>}
            <button className="btn btn-primary btn-block" style={{ marginTop: 14 }} disabled={busy} onClick={doLoginManager}>Entrar</button>
            <div className="switch-role">É funcionário? <a onClick={() => { setMode('employee'); setError(''); }}>Voltar ao login por PIN</a></div>
          </>
        )}

        {mode === 'forgot' && (
          <>
            <h2>Esqueceu seu PIN?</h2>
            <p className="hint">Confirme seu CPF e telefone completo (os mesmos do seu cadastro) para definir um novo PIN.</p>
            <label>CPF</label>
            <input type="text" placeholder="000.000.000-00" value={cpf} onChange={(e) => setCpf(e.target.value)} />
            <label>Telefone completo</label>
            <input type="text" placeholder="(71) 90000-0000" value={telefone} onChange={(e) => setTelefone(e.target.value)} />
            <label>Novo PIN (4 dígitos)</label>
            <PinBoxInput value={novoPin} onChange={setNovoPin} />
            <label>Confirme o novo PIN</label>
            <PinBoxInput value={novoPin2} onChange={setNovoPin2} onEnter={doResetPin} />
            {error && <div className="err">{error}</div>}
            <button className="btn btn-primary btn-block" style={{ marginTop: 14 }} disabled={busy} onClick={doResetPin}>Trocar PIN e entrar</button>
            <div className="switch-role"><a onClick={() => { setMode('employee'); setError(''); }}>Voltar ao login por PIN</a></div>
          </>
        )}
      </div>
    </div>
  );
}
